<div fxLayoutAlign="center center">
  <form fxFlex="1 1 60%;" #fUpdateInfo="ngForm" (ngSubmit)="onUpdateInfo(fUpdateInfo.value)"
        role="submit" [appMatchPassword]="['new_password','confirm_password']">
    <mat-card fxFlex>
      <mat-card-header fxLayoutAlign="space-between center" style="padding-bottom: 16px;">
        <mat-card-title fxLayoutGap="10px" role="heading" aria-level="1">Update Password</mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="column" fxLayoutAlign="center" fxLayoutGap="10px grid">
        <mat-form-field *ngIf="!expired && !newUser" fxFlex="50%" floatLabel="always" appearance="outline">
          <mat-label>Current Password</mat-label>
          <input matInput name="old_password" #old_password="ngModel" required type="password" [(ngModel)]="oldPassword"
                 [appValidatePassword]="'/user/validate-old-password'">
          <button mat-icon-button *ngIf="oldPassword" matSuffix aria-label="Clear" (click)="oldPassword=undefined">
            <mat-icon>close</mat-icon>
          </button>
          <div *ngIf="old_password.invalid && (old_password.dirty || old_password.touched)">
            <mat-error *ngIf="old_password.errors?.['passwordInValid']">
              Invalid Current Password
            </mat-error>
          </div>
        </mat-form-field>
        <mat-form-field fxFlex="50%" floatLabel="always" appearance="outline">
          <mat-label>New Password</mat-label>
          <input matInput name="new_password" required #new_password="ngModel" type="password" maxlength="32"
                 [(ngModel)]="newPassword"
                 [appValidateNewPassword]="'/user/validate-password'"
                 (validateNewPasswordEvent)="handlePasswordInvalidEvent($event)">
          <button mat-icon-button *ngIf="newPassword" matSuffix aria-label="Clear" (click)="newPassword=undefined">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <div *ngIf="new_password.invalid && (new_password.dirty || new_password.touched)">
          <mat-error *ngIf="new_password?.errors?.['passwordInValidWithData']">
            <ul>
              <li *ngFor="let item of passwordInvalidData">{{ item }}</li>
            </ul>
          </mat-error>
        </div>
        <mat-form-field fxFlex="50%" floatLabel="always" appearance="outline">
          <mat-label>Confirm Password</mat-label>
          <input matInput name="confirm_password" required #confirm_password="ngModel" type="password" maxlength="32"
                 [(ngModel)]="confirmPassword" [disabled]="!newPassword || !new_password.valid">
          <button mat-icon-button *ngIf="confirmPassword" matSuffix aria-label="Clear"
                  (click)="confirmPassword=undefined">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <div *ngIf="confirm_password.invalid && (confirm_password.dirty || confirm_password.touched)">
          <mat-error *ngIf="confirm_password?.errors?.['misMatch']">
            New password and confirm password must match
          </mat-error>
        </div>

      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutAlign="center" fxLayoutGap="5px">
        <button color="primary" mat-raised-button type="submit" [disabled]="fUpdateInfo.invalid || !fUpdateInfo.dirty || isLoading">Update
          Info</button>
        <button mat-raised-button color="warn" mat-raised-button type="reset" (click)="fUpdateInfo.reset()">Cancel</button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
